/* eslint-disable */
import React, { Component } from 'react';
import '../css/Button.scss';
import PropTypes from 'prop-types';
import HTMLText from './HTMLText';

/**
* @augments {Component<{  className:string,  onClickAction:Function,  text:string>}
*/
class Button extends Component {

	constructor(props) {
		super(props);
		
		this.state = {
			text : this.props.text,
			className : this.props.className,
		};
		
	}
	
	componentDidMount() {		
	}
	
	componentWillUnmount() {
	}

	componentWillReceiveProps(nextProps) {
		this.setState({text:nextProps.text, className:nextProps.className});
	} 
	
	

	render() {
		return (
			<React.Fragment>				
				<div className={this.state.className}  
					onClick={this.props.onClickAction} ><HTMLText text={this.state.text}/></div>				
			</React.Fragment>			
		);
	}
}

Button.propTypes = {
  className: PropTypes.string,
  onClickAction: PropTypes.func,
  text: PropTypes.string
}



export default Button;